import * as React from "react";
import { Button, Modal } from "semantic-ui-react";
import { set_focus_on_element_with_id } from '../../shared/tab_navigation_utility';

interface MaxAllowedTabsProps {
    show: boolean;
    onClose: () => void;
}

class MaxAllowedTabs extends React.Component<MaxAllowedTabsProps, any> {
    _is_mounted = false;

    componentDidMount() {
        this._is_mounted = true;
    }

    componentWillUnmount() {
        this._is_mounted = false;
    }

    handleClose = () => {
        if (this._is_mounted) {           
            set_focus_on_element_with_id("open_ledger_handle_icon");
            this.props.onClose();
        }
    }

    render() {
        return (
            <Modal
                onClose={this.handleClose}
                open={this.props.show}
                centered={false}
                closeIcon
                closeOnDimmerClick={false}
                className="max_allowed_tabs add-new-note"
                size="small"
                id={"max_allowed_tabs"}                
            >
                <Modal.Header className='max-allowed-tabs-header'>Max WebPT Billing Tabs Reached</Modal.Header>
                <Modal.Content id={"maxAllowedTabsContent"}>
                    <Modal.Description>
                        <div className="common-forms" style={{ padding: '0px' }}>
                            <p>Your browser has reached the maximum allowed number of WebPT Billing tabs.</p>
                            <p>Please close one or more tabs to be able to open this patient’s ledger.</p>
                        </div>
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button 
                        id="max_tabs_ok_button"
                        onClick={this.handleClose} 
                        primary
                    >
                        Ok
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }
}

export default MaxAllowedTabs;
